import { render } from "./opportunity-page.vue?vue&type=template&id=52600add&ts=true"
import script from "./opportunity-page.vue?vue&type=script&lang=ts"
export * from "./opportunity-page.vue?vue&type=script&lang=ts"

import "./opportunity-page.vue?vue&type=style&index=0&id=52600add&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__